import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  fetchPreBookingDetail,
  setBookingDates,
} from "../../../Redux/Slices/BON-Frontend/roomAvailabilitySlice";

export const BannerSearchBar = ({ checkInDate, checkOutDate }) => {
  const dispatch = useDispatch();

  const getPropertyId = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("pid");
  };

  const MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [calTarget, setCalTarget] = useState(null);
  const [calYear, setCalYear] = useState(2026);
  const [calMonth, setCalMonth] = useState(4);
  const [calendarStyle, setCalendarStyle] = useState({});
  const today = new Date();

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const [checkinDate, setCheckinDate] = useState(
    checkInDate ? new Date(checkInDate) : today,
  );

  const [checkoutDate, setCheckoutDate] = useState(
    checkOutDate ? new Date(checkOutDate) : tomorrow,
  );
  const [showCalendar, setShowCalendar] = useState(false);
  const [showGuestDropdown, setShowGuestDropdown] = useState(false);
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const wrapperRef = useRef(null);

  const formatDate = (d) => {
    return (
      d.getDate().toString().padStart(2, "0") +
      " " +
      MONTHS[d.getMonth()] +
      " " +
      d.getFullYear()
    );
  };

  const toggleCalendar = (target) => {
    setShowGuestDropdown(false);
    if (calTarget === target && showCalendar) {
      setShowCalendar(false);
      setCalTarget(null);
      return;
    }
    setCalTarget(target);
    const activeDate = target === "checkin" ? checkinDate : checkoutDate;
    setCalYear(activeDate.getFullYear());
    setCalMonth(activeDate.getMonth());
    const field = document.getElementById(
      target === "checkin" ? "checkin-field" : "checkout-field",
    );
    const heroSection = document.querySelector(".bp-hero-banner");
    const heroRect = heroSection.getBoundingClientRect();
    const fieldRect = field.getBoundingClientRect();
    setCalendarStyle({
      left: `${fieldRect.left - heroRect.left}px`,
      top: `${fieldRect.bottom - heroRect.top + 8}px`,
    });
    setShowCalendar(true);
  };

  const selectDate = (date) => {
    if (calTarget === "checkin") {
      setCheckinDate(date);
      if (date >= checkoutDate) {
        setCheckoutDate(
          new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1),
        );
      }
    } else {
      if (date <= checkinDate) {
        setCheckinDate(
          new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1),
        );
      }
      setCheckoutDate(date);
    }
    setTimeout(() => {
      setShowCalendar(false);
      setCalTarget(null);
    }, 200);
  };

  const prevMonth = () => {
    if (calMonth === 0) {
      setCalMonth(11);
      setCalYear((prev) => prev - 1);
    } else {
      setCalMonth((prev) => prev - 1);
    }
  };

  const nextMonth = () => {
    if (calMonth === 11) {
      setCalMonth(0);
      setCalYear((prev) => prev + 1);
    } else {
      setCalMonth((prev) => prev + 1);
    }
  };

  const toggleGuestDropdown = (e) => {
    e.stopPropagation();
    setShowCalendar(false);
    setCalTarget(null);
    setShowGuestDropdown((prev) => !prev);
  };

  const changeGuest = (type, delta) => {
    if (type === "adult") {
      setAdults((prev) => Math.max(1, prev + delta));
    } else {
      setChildren((prev) => Math.max(0, prev + delta));
    }
  };

  const closeGuestDropdown = () => {
    setShowGuestDropdown(false);
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowCalendar(false);
        setShowGuestDropdown(false);
        setCalTarget(null);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const firstDay = new Date(calYear, calMonth, 1).getDay();
  const daysInMonth = new Date(calYear, calMonth + 1, 0).getDate();

  const formatApiDate = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

  // Ye add karo existing useEffects ke saath
  useEffect(() => {
    const propertyId = getPropertyId();

    dispatch(
      setBookingDates({
        checkInDate: formatApiDate(checkinDate),
        checkOutDate: formatApiDate(checkoutDate),
      }),
    );

    if (propertyId) {
      dispatch(
        fetchPreBookingDetail({
          PropertyID: propertyId,
          CheckIn: formatApiDate(checkinDate),
          CheckOut: formatApiDate(checkoutDate),
        }),
      );
    }
  }, []);

  const handleSearchRooms = () => {
    dispatch(
      setBookingDates({
        checkInDate: formatApiDate(checkinDate),
        checkOutDate: formatApiDate(checkoutDate),
      }),
    );

    dispatch(
      fetchPreBookingDetail({
        PropertyID: getPropertyId(),
        CheckIn: formatApiDate(checkinDate),
        CheckOut: formatApiDate(checkoutDate),
      }),
    );
  };

  return (
    <>
      {/* SEARCH BAR */}
      <div className="bp-hero-search-bar">
        {/* CHECK IN */}
        <div
          className="bp-hero-search-field"
          id="checkin-field"
          onClick={() => toggleCalendar("checkin")}
        >
          <div className="bp-hero-search-field-label">Check In</div>
          <div className="bp-hero-search-field-value">
            {formatDate(checkinDate)}
          </div>
        </div>

        {/* CHECK OUT */}
        <div
          className="bp-hero-search-field"
          id="checkout-field"
          onClick={() => toggleCalendar("checkout")}
        >
          <div className="bp-hero-search-field-label">Check Out</div>
          <div className="bp-hero-search-field-value">
            {formatDate(checkoutDate)}
          </div>
        </div>

        {/* GUESTS */}
        <div
          className="bp-hero-search-field"
          id="guests-field"
          onClick={toggleGuestDropdown}
        >
          <div className="bp-hero-search-field-label">Guests</div>
          <div className="bp-hero-search-field-value">
            {adults} Adults · {children} Children
          </div>
        </div>

        {/* SEARCH BUTTON */}
        <button className="bp-hero-search-btn" onClick={handleSearchRooms}>
          <span className="material-symbols-outlined" style={{ fontSize: 18 }}>
            search
          </span>
          Search Rooms
        </button>
      </div>

      {/* CALENDAR POPUP */}
      {showCalendar && (
        <div
          id="calendar-popup"
          style={{
            display: "block",
            position: "absolute",
            zIndex: "100",
            background: "white",
            borderRadius: "12px",
            boxShadow: "rgba(0, 0, 0, 0.18) 0px 8px 32px",
            padding: "20px",
            minWidth: "320px",
            ...calendarStyle,
            top: "388px",
          }}
        >
          {/* HEADER */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 16,
            }}
          >
            <button
              onClick={prevMonth}
              style={{
                border: "none",
                background: "#f5f3f3",
                borderRadius: "50%",
                width: 32,
                height: 32,
                cursor: "pointer",
                fontSize: 16,
              }}
            >
              ‹
            </button>
            <span
              style={{
                fontWeight: 700,
                fontSize: 15,
                fontFamily: '"Noto Serif",serif',
              }}
            >
              {MONTHS[calMonth]} {calYear}
            </span>
            <button
              onClick={nextMonth}
              style={{
                border: "none",
                background: "#f5f3f3",
                borderRadius: "50%",
                width: 32,
                height: 32,
                cursor: "pointer",
                fontSize: 16,
              }}
            >
              ›
            </button>
          </div>

          {/* WEEK DAYS */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(7,1fr)",
              gap: 4,
              textAlign: "center",
            }}
          >
            {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((day) => (
              <div
                key={day}
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "#999",
                  padding: 4,
                }}
              >
                {day}
              </div>
            ))}
          </div>

          {/* DAYS */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(7,1fr)",
              gap: 4,
              textAlign: "center",
              marginTop: 4,
            }}
          >
            {Array.from({ length: firstDay }).map((_, i) => (
              <div key={i}></div>
            ))}
            {Array.from({ length: daysInMonth }).map((_, i) => {
              const d = i + 1;
              const date = new Date(calYear, calMonth, d);
              const isCheckin =
                date.toDateString() === checkinDate.toDateString();
              const isCheckout =
                date.toDateString() === checkoutDate.toDateString();
              const inRange = date > checkinDate && date < checkoutDate;
              const isPast =
                date < today && date.toDateString() !== today.toDateString();
              return (
                <button
                  key={d}
                  disabled={isPast}
                  onClick={() => selectDate(date)}
                  style={{
                    border: "none",
                    background:
                      isCheckin || isCheckout
                        ? "#775a19"
                        : inRange
                          ? "rgba(119,90,25,0.12)"
                          : "transparent",
                    color:
                      isCheckin || isCheckout
                        ? "#fff"
                        : isPast
                          ? "#ccc"
                          : "#000",
                    width: 36,
                    height: 36,
                    borderRadius: "50%",
                    cursor: isPast ? "default" : "pointer",
                    fontSize: 13,
                    fontWeight: isCheckin || isCheckout ? "700" : "500",
                  }}
                >
                  {d}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* GUEST DROPDOWN */}
      {showGuestDropdown && (
        <div
          id="guest-dropdown"
          style={{
            display: "block",
            position: "absolute",
            zIndex: "100",
            background: "white",
            borderRadius: "12px",
            boxShadow: "rgba(0, 0, 0, 0.18) 0px 8px 32px",
            padding: "20px",
            minWidth: "280px",
            left: "583.516px",
            top: "388px",
          }}
        >
          {/* ADULTS */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 16,
            }}
          >
            <div>
              <div style={{ fontWeight: 600, fontSize: 14 }}>Adults</div>
              <div style={{ fontSize: 12, color: "#999" }}>Age 13+</div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <button
                onClick={() => changeGuest("adult", -1)}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  border: "1px solid #d1c5b4",
                  background: "white",
                  fontSize: 18,
                  cursor: "pointer",
                  color: "#775a19",
                }}
              >
                −
              </button>
              <span
                style={{
                  fontWeight: 700,
                  fontSize: 16,
                  minWidth: 20,
                  textAlign: "center",
                }}
              >
                {adults}
              </span>
              <button
                onClick={() => changeGuest("adult", 1)}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  border: "1px solid #d1c5b4",
                  background: "white",
                  fontSize: 18,
                  cursor: "pointer",
                  color: "#775a19",
                }}
              >
                +
              </button>
            </div>
          </div>

          {/* CHILDREN */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingTop: 16,
              borderTop: "1px solid #f0ece4",
            }}
          >
            <div>
              <div style={{ fontWeight: 600, fontSize: 14 }}>Children</div>
              <div style={{ fontSize: 12, color: "#999" }}>Age 0–12</div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <button
                onClick={() => changeGuest("child", -1)}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  border: "1px solid #d1c5b4",
                  background: "white",
                  fontSize: 18,
                  cursor: "pointer",
                  color: "#775a19",
                }}
              >
                −
              </button>
              <span
                style={{
                  fontWeight: 700,
                  fontSize: 16,
                  minWidth: 20,
                  textAlign: "center",
                }}
              >
                {children}
              </span>
              <button
                onClick={() => changeGuest("child", 1)}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  border: "1px solid #d1c5b4",
                  background: "white",
                  fontSize: 18,
                  cursor: "pointer",
                  color: "#775a19",
                }}
              >
                +
              </button>
            </div>
          </div>

          {/* DONE */}
          <button
            onClick={closeGuestDropdown}
            style={{
              marginTop: 16,
              width: "100%",
              padding: 10,
              background: "#775a19",
              color: "white",
              border: "none",
              borderRadius: 8,
              fontWeight: 700,
              fontSize: 13,
              cursor: "pointer",
              letterSpacing: "0.05em",
            }}
          >
            Done
          </button>
        </div>
      )}
    </>
  );
};
